import React from "react";
import classNames from "classnames";
import { EditRounded, ReportProblemOutlined } from "@material-ui/icons";
import { Text } from "components/commons";
import styles from "./status-card.module.scss";
import { locale } from "localization/en";
import { OrderStatus } from "enums";
import { dateTimeFormatv2 } from "utils";

const StatusCard = ({ status, className, style, ...statusCardInfo }) => {
  const renderIcon = () => {
    switch (status) {
      case OrderStatus.Rejected:
        return <ReportProblemOutlined className={styles.icon} />;
      case OrderStatus.ForRevision:
        return <EditRounded className={styles.icon} />;
      default:
        return null;
    }
  };

  return (
    <div
      className={classNames(styles.card, className, {
        [styles.rejected]: status === OrderStatus.Rejected,
        [styles.forRevision]: status === OrderStatus.ForRevision,
      })}
      style={style}
    >
      <div className={styles.header}>
        {renderIcon()}
        <div className={styles.titleWrapper}>
          <Text className={styles.title}>{statusCardInfo?.title}</Text>
          {statusCardInfo?.date && (
            <Text className={styles.date}>{dateTimeFormatv2(statusCardInfo?.date)}</Text>
          )}
        </div>
      </div>
      <div className={styles.container}>
        {statusCardInfo?.reason && <Text className={styles.reason}>{statusCardInfo?.reason}</Text>}
        <br />
        {statusCardInfo?.remarks && (
          <div className={styles.remarks}>
            <Text bold className={styles.remarksLabel}>
              {locale.remarks}
            </Text>
            <Text className={styles.reason}>{statusCardInfo?.remarks}</Text>
          </div>
        )}
      </div>
    </div>
  );
};

export default StatusCard;
